import { LoadNotifications, LoadTeams } from '../../connection/home';
import { Channel } from '../reducers/home';

interface AsyncAction {
	type: string;
	promise: Promise<any>
}

export const SET_HOME_ROUTE = "SET_HOME_ROUTE";
export function setHomeRoute(route: number) {
	return {
		type: SET_HOME_ROUTE,
		payload: route
	}
}

export const SET_HOME_CHANNEL = "SET_HOME_CHANNEL";
export function setHomeChannel(channel: Channel) {
	return {
		type: SET_HOME_CHANNEL,
		payload: channel
	}
}

export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export function loadNotifications(token: string): AsyncAction {
	return {
		type: LOAD_NOTIFICATIONS,
		promise: LoadNotifications(token)
	}
}

export const SET_HOME_MEETING = "SET_HOME_MEETING";
export function setHomeMeeting(event: any) {
	return {
		type: SET_HOME_MEETING,
		payload: event
	}
}

export const LOAD_TEAMS = "LOAD_TEAMS";
export function loadTeams(token: string, channels: { events_legacy_channels: Channel[], gr_channels: Channel[] }) {
	return {
		type: LOAD_TEAMS,
		promise: LoadTeams(token, channels)
	}
}